'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dGroup$002dSigning$002dView$0024$0024anon$002465 from "./presto.-Group-Signing-View$$anon$65.js";
import * as $j_presto$002etypes$0024proto$0024$002dGroup$002dSigning$0024 from "./presto.types$proto$-Group-Signing$.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupSigningView$$anon$64() {
  this.aX8 = null;
  this.aX0 = null;
  this.aX1 = false;
  this.aX9 = null;
  this.aXa = false;
  this.aXd = null;
  this.aX6 = null;
  this.aX7 = false;
  this.aX2 = null;
  this.aX3 = false;
  this.aX4 = null;
  this.aX5 = false;
  this.aXb = false;
  this.aXc = false;
  this.aX8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aXd = "GroupSigning";
}
export { $c_Lpresto_GroupSigningView$$anon$64 as $c_Lpresto_GroupSigningView$$anon$64 };
$p = $c_Lpresto_GroupSigningView$$anon$64.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupSigningView$$anon$64;
/** @constructor */
function $h_Lpresto_GroupSigningView$$anon$64() {
}
export { $h_Lpresto_GroupSigningView$$anon$64 as $h_Lpresto_GroupSigningView$$anon$64 };
$h_Lpresto_GroupSigningView$$anon$64.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aX8;
});
$p.M = (function() {
  if ((!this.aX1)) {
    this.aX0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aX1 = true;
  }
  return this.aX0;
});
$p.O = (function() {
  if ((!this.aXa)) {
    this.aX9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aXa = true;
  }
  return this.aX9;
});
$p.E = (function() {
  return this.aXd;
});
$p.t = (function() {
  if ((!this.aX7)) {
    this.aX6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("blocked", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aX7 = true;
  }
  return this.aX6;
});
$p.N = (function() {
  if ((!this.aX3)) {
    this.aX2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().at, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.aX3 = true;
  }
  return this.aX2;
});
$p.Q = (function() {
  if ((!this.aX5)) {
    this.aX4 = new $j_presto$002e$002dGroup$002dSigning$002dView$0024$0024anon$002465.$c_Lpresto_GroupSigningView$$anon$65();
    this.aX5 = true;
  }
  return this.aX4;
});
$p.v = (function() {
  if ((!this.aXc)) {
    this.aXb = false;
    this.aXc = true;
  }
  return this.aXb;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee479) => ((p) => \u03b4scrutinee479.cGh(p)))($j_presto$002etypes$0024proto$0024$002dGroup$002dSigning$0024.$m_Lpresto_types$proto$GroupSigning$())));
});
var $d_Lpresto_GroupSigningView$$anon$64 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupSigningView$$anon$64, "presto.GroupSigningView$$anon$64", ({
  JI: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_GroupSigningView$$anon$64 as $d_Lpresto_GroupSigningView$$anon$64 };
//# sourceMappingURL=presto.-Group-Signing-View$$anon$64.js.map
